import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import React from 'react';
import type { FC } from 'react';

import Icon, { IconTypes } from 'components/basic/Icon';
import { BodyL, BodyM } from 'components/basic/Typography';
import s from 'components/layouts/FullFooter/FullFooter.module.scss';
import { socialItems } from 'components/layouts/FullFooter/constants';

const SocialItems: FC = () => {
  const items = socialItems.map(({ analyticsButtonId, href, icon, text }) => {
    return (
      <BodyM
        key={analyticsButtonId}
        Tag="a"
        href={href}
        className={s.link}
        onClick={(): void => {
          logEvent('Web_Site_Footer_Social_Logo_Clicked', {
            button_id: analyticsButtonId,
          });
        }}
      >
        <Icon icon={IconTypes[icon]} className={s.appIcon} color="fon_1" />
        {text}
      </BodyM>
    );
  });

  return (
    <div key="socials" className={s.linksItem}>
      <BodyL className={cn('mb-5', s.header)}>Social</BodyL>
      {items}
    </div>
  );
};

export default SocialItems;
